var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EPeriod } from "@domains/features/Markets/Options/entites/drivingMarket";
import { SET_PARAMS, DRIVING_MKT_CLEAR_MSG, DRIVING_MKT_SET_MSG, } from "../../interface/drivingMarket/iOptionDrivingMarketParams";
export var initCommonState = {
    limit: true,
    period: EPeriod.ONE_DAY,
    callMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    putMessage: {
        msg: null,
        show: false,
        icon: null,
    },
};
var drivingMarketParamsReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initCommonState; }
    switch (action.type) {
        case SET_PARAMS:
            return __assign(__assign({}, state), action.payload);
        case DRIVING_MKT_SET_MSG:
            return __assign(__assign({}, state), (_a = {}, _a[action.callPutType] = action.callPutMsg, _a));
        case DRIVING_MKT_CLEAR_MSG:
            return __assign(__assign({}, state), (_b = {}, _b[action.callPutType] = initCommonState[action.callPutType], _b));
        default:
            return __assign({}, state);
    }
};
export default drivingMarketParamsReducer;
